<lib-page-header screenName="My Profile" [title]="myProfile.displayName">
    <span icon class="profile-avatar">{{ myProfile.getUserInitials() }}</span>
    <ng-container subtitle *ngIf="myProfile.user.username">
        <mat-icon class="meta-icon">badge</mat-icon> {{ myProfile.user.username }}
        <span class="meta-sep">·</span>
        <mat-icon class="meta-icon">email</mat-icon> {{ myProfile.user.email || '—' }}
    </ng-container>
    <ng-container actions>
        <button mat-flat-button color="primary"
                [disabled]="!myProfile.canSave()" (click)="myProfile.onSave()">
            <mat-icon>save</mat-icon>
            Save
        </button>
    </ng-container>
</lib-page-header>

<lib-my-profile #myProfile></lib-my-profile>
